module.exports = function () {
	return require("./index").apply(this, arguments);
}


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/__main_entry.tmp.js
// module id = 83
// module chunks = 4